import { render } from "./BackLayout.vue?vue&type=template&id=094919b2&scoped=true"
import script from "./BackLayout.vue?vue&type=script&lang=js"
export * from "./BackLayout.vue?vue&type=script&lang=js"

import "./BackLayout.vue?vue&type=style&index=0&id=094919b2&lang=scss&scoped=true"

import exportComponent from "C:\\xampp\\htdocs\\Ltd24ore-client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-094919b2"]])

export default __exports__